import { gql } from "@apollo/client"

export const VALIDATE_KEY = gql`
  query validateKey($key: String!) {
    validateDevTools(key: $key) {
      isValid
    }
  }
`
